<template>
  <v-container>
    <v-layout v-if="isLoading" style="padding-top: 150px;">
      <PageLoader resourceName="Configurations" />
    </v-layout>
    
    <Index :configurations="configurations" :form="dynamicFormComponent" @fetchConfigurations="fetchConfigurations(service)" v-if="!isLoading" />
    <CreateDialog @fetchConfigurations="fetchConfigurations(service)" v-if="!isLoading" />
  </v-container>
</template>

<script>
  import Index from './Index'
  import CreateDialog from './CreateConfigurationDialog'

  import externalComponentLoader from './external-component-loader'
  import externalCssLoader from './external-css-loader'

  const componentId = 'masterui-component-form'
  const cssId = 'masterui-component-css'

  export default {
    components: {
      Index,
      CreateDialog,
    },
    data() {
      return {
        dynamicFormComponent: null,
        navItems: [{
          text: 'System Administration',
          to: {
            name: 'administration',
          },
        },
        {
          text: 'Manage Services',
          to: {
            name: 'manageservices',
          },
        },
        {
          text: 'Manage Configurations',
          disabled: true,
        },
        ],
        isLoading: true,
      }
    },
    computed: {
      Id() {
        return this.$route.params.id
      },
      configurations() {
        return this.$store.getters['serviceconfigurations/configurations']
      },
      currentService() {
        return this.$store.getters['serviceconfigurations/currentService']
      },
      services() {
        return this.$store.getters['services/services']
      },
      service() {
        console.log('The service Id is ' + this.Id)
        return this.services.find(s => s.Id == this.Id)
      },
      componentUrl: function() {
        return 'api/ServiceRegistry/Services/' + this.service.Id + '/js/ConfigurationForm.umd.min.js'
      },
      cssUrl: function() {
        return 'api/ServiceRegistry/Services/' + this.service.Id + '/css'
      },
    },
    methods: {
      async fetchService(service) {
        this.$store.dispatch('serviceconfigurations/setCurrentService', service)
      },
      async fetchConfigurations(service) {
        this.isLoading = true
        let response = await this.$store.dispatch('serviceconfigurations/fetchConfigurations', service)
        console.log('configurations', response, response.data)
        let that = this
        setTimeout(() => that.isLoading = false, 300)
        
        this.$store.dispatch('serviceconfigurations/setConfigurations', response.data)
      },
    },
    created() {
      if(this.service == null) {
        alert('Service registry list is not loaded yet. Please get back to the service listing page.')
        this.isLoading = false
      }
      let component = () => externalComponentLoader(componentId, this.componentUrl)

      externalCssLoader(cssId, this.cssUrl)
        .catch((error) => {
          console.warn('Could not load the optional css file, which can happen if the service did not have one!',
            error)
        })

      this.dynamicFormComponent = component
      this.$store.dispatch('serviceconfigurations/setFormComponent', component)

      this.fetchService(this.service)

      this.isLoading = true
      this.fetchConfigurations(this.service)
    },
    beforeDestroy() {
      let css = document.getElementById(cssId)
      if (css) {
        //console.log('Removing service component css')
        css.parentElement.removeChild(css)
      }

      let component = document.getElementById(componentId)
      if (component) {
        //console.log('Removing service component')
        component.parentElement.removeChild(component)
      }
    },
  }
</script>

<style>
  .v-input--selection-controls {
    margin-top: 6px;
  }

  .service-configuration-form legend {
    background-color: #000;
    color: #fff;
    padding: 3px 8px;
  }

  .service-configuration-form form.v-form {
    width: 100% !important;
  }

  .service-configuration-form .text-center {
    text-align: center;
  }

  .service-configuration-form fieldset {
    display: block;
    margin-inline-start: 2px;
    margin-inline-end: 2px;
    padding-block-start: 0.35em;
    padding-inline-start: 0.75em;
    padding-inline-end: 0.75em;
    padding-block-end: 0.625em;
    min-inline-size: min-content;
    border-width: 2px;
    border-style: groove;
    border-color: threedface;
    border-image: initial;
    border-left: none;
    border-right: none;
    border-bottom: none;
    margin-top: 10px;
    padding-top: 10px;
  }

  .service-configuration-form .text--dark {
    color: black;
  }

  .service-configuration-form .dark-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.3;
    filter: alpha(opacity=60);
    z-index: 5;
  }

  span.activeFtpFolder {
    background-color: khaki;
  }
</style>